import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table, Form, Row, Col, FloatingLabel, Button } from 'react-bootstrap';
import SolicitacaoService from '../../../../../services/solicitacao';
import ComponentesService from '../../../../../services/componentes';
import Componente from './componente';
import '../../../../../styles/diario.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import FormBusca from './busca';
import { useParams } from 'react-router-dom';


const SolicitCompsScreen = () => {
    let { id } = useParams()
    const [componentes, setComponentes] = useState([]);
    const [componentesOriginais, setComponentesOriginais] = useState([]);
    const [componentesTotal, setComponentesTotal] = useState([]);
    const [situacao, setSituacao] = useState("");
    const [componenteId, setComponenteId] = useState("");
    const [qtd, setQtd] = useState("");
    const [searchText, setSearchText] = useState("");
    const [filteredComps, setFilteredComps] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(false);

    async function fetchComps(id) {
        setLoading(true)
        const resp = await ComponentesService.listar();
        setComponentesTotal(resp.data)
        const response = await SolicitacaoService.verSolicitacao(id);
        if (response.data["componentes"].length >= 1) {
            if (response.data["situacao"] === "Respondida") {
                setSituacao("respondidas")
            } else {
                setSituacao("pendentes")
            }
            setComponentes(response.data["componentes"]);
            setComponentesOriginais(response.data["componentes"]);
            setLoading(false)
            setVazio(false)
        } else {
            setLoading(false);
            setComponentes([]);
            setComponentesOriginais([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (categoria, nome) => {

        // Se todos vazios → voltar ao original
        if (!categoria.trim() && !nome.trim()) {
            setComponentes(componentesOriginais);
            setVazio(false);
            return;
        }

        const filtrados = componentesOriginais.filter(f => {

            const matchCategoria = categoria.trim()
                ? String(f.componente.categoria.toLowerCase()).includes(categoria.toLowerCase())
                : true;

            const matchNome = nome.trim()
                ? String(f.componente.nome.toLowerCase()).includes(nome.toLowerCase())
                : true;
            return matchCategoria && matchNome;
        });

        if (filtrados.length >= 1) {
            setComponentes(filtrados);
            setVazio(false);
        } else {
            setComponentes([]);
            setVazio(true);
        }
    };

    const deletar = async (idSol, comp) => {
        if (window.confirm(`Tem certeza que deseja excluir o componente da solicitação?`)) {
            try {
                await SolicitacaoService.delComponente(idSol, { componente: comp })
                alert("Componente deletado da solicitação com sucesso!")
                fetchComps(idSol);
            } catch (err) {
                alert(err)
            }
        }
    }

    const HandleSubmit = async (e) => {
        e.preventDefault()
        try {
            const com = await SolicitacaoService.novoComponente(id, {
                componente: componenteId,
                qtd: qtd
            })
            setError(false)
            setQtd("")
            alert("Solicitação atualizada com sucesso!")
            fetchComps(id)
        } catch (error) {
            setError(error)
        }
    }

    const handleSearch = (e) => {
        const searchText = e;
        setSearchText(searchText);

        // Filtrar os produtos com base no texto digitado
        const filtered = componentesTotal.filter((compo) =>
            compo.nome.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredComps(filtered);
    };

    useEffect(() => {
        fetchComps(id);
    }, [id]);

    return (
        <Fragment>
            <Container>
                <Fragment>
                    <FormBusca
                        filtrarLocalmente={filtrarLocalmente}
                        setComponentes={setComponentes}
                        componentesOriginais={componentesOriginais}
                        situacao={situacao}
                    />
                    <br />
                </Fragment>
                <Form onSubmit={HandleSubmit} >
                    <Row xs={1} lg={3}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="componente">
                                <FloatingLabel
                                    label="Componente"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="searchText"
                                        value={searchText}
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <Form.Select
                                        required
                                        aria-label="Componente"
                                        name="componente"
                                        onChange={e => setComponenteId(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {filteredComps
                                            .map((compo) => (
                                                <option key={compo._id} value={compo._id}>
                                                    {compo.nome}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="qtd">
                                <FloatingLabel
                                    label="Quantidade"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="qtd"
                                        value={qtd}
                                        onChange={e => setQtd(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                        <Col xs={12} lg={2}>
                            <Button variant="success" type="submit">
                                <FontAwesomeIcon icon={faCirclePlus} />
                            </Button>
                        </Col>
                    </Row>
                </Form >
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <br />
                        <Table className="table table-bordered tabela-rh">
                            <thead>
                                <tr>
                                    <th>Componente</th>
                                    <th>Categoria</th>
                                    <th>Tipo</th>
                                    <th>Qtd</th>
                                    <th>Excluir</th>
                                </tr>
                            </thead>
                            <tbody>
                                {componentes.map((componente, index) =>
                                    <Componente
                                        componente={componente}
                                        solic={id}
                                        key={index}
                                        deletar={deletar}
                                    />
                                )}
                            </tbody>
                        </Table>
                        {loading && (
                            <Container className="text-center mt-5">
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status" />
                                </div>
                                <p className="mt-3">⏳ Carregando dados, aguarde...</p>
                            </Container>

                        )}
                    </Fragment>}
            </Container>
        </Fragment>

    )
}

export default SolicitCompsScreen;